import { motion } from "framer-motion";
import { Button } from "../../components/ui/button";
import { Sparkles } from "lucide-react";

/**
 * Final "Prêt à décrocher vos prochains marchés ?" CTA before the footer.
 * Receives the modal opener as a prop to stay decoupled from page state.
 */
export default function CtaFinalSection({ onTryFree }) {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="font-display text-3xl md:text-4xl font-semibold text-slate-900 mb-6">
            Prêt à décrocher vos prochains marchés ?
          </h2>
          <p className="text-slate-600 text-lg mb-8">
            Testez gratuitement sans inscription et découvrez les marchés qui vous correspondent.
          </p>
          <Button
            size="lg"
            onClick={onTryFree}
            className="bg-violet-700 hover:bg-violet-800 text-white rounded-full px-10 py-6 text-lg shadow-lg hover:shadow-xl transition-all"
            data-testid="cta-final-btn"
          >
            <Sparkles className="mr-2 w-5 h-5" />
            Essayer gratuitement
          </Button>
        </motion.div>
      </div>
    </section>
  );
}
